export default __webpack_public_path__ + "static/media/ChipCloseIcon.504ef91d.svg";